import { GeoJSON } from "geojson";
import { DatasetRecord } from "@/types/DatasetRecord";
import { displayCoordinates, meterSquaredToAcres } from "@/util/helpers";
import { AnyAddress, IDisplaySection, ILocation, locationType } from "@/types";
import { area, centroid } from "@turf/turf";
import { GammaAccuracy } from "@/types/location/location-accuracy";

export class GeometryLocation implements ILocation {
  address?: AnyAddress;
  record?: DatasetRecord;
  type: locationType = "Geometry";

  readonly _data: ILocation;

  readonly geometry!: GeoJSON.Point;

  private readonly _geometry: GeoJSON.Geometry;

  readonly title: string;
  constructor(data: { type: locationType; geometry: GeoJSON.Geometry }) {
    this._data = data;
    this._geometry = data.geometry;
    Object.assign(this, data);
    this.title = displayCoordinates(
      centroid(this._geometry as any).geometry.coordinates
    );
  }

  get precisionAccuracy(): GammaAccuracy | undefined {
    return this._data.precisionAccuracy;
  }

  get addressLinkRequest() {
    return {
      Geometry: this._geometry,
    };
  }

  get displaySections(): IDisplaySection[] {
    const areaInMSquared = area(this.geometry);
    const areaInHectars = meterSquaredToAcres(areaInMSquared);
    return [
      {
        name: "Geometry",
        type: "Geometry",
        items: [
          {
            name: "Centroid",
            value: this.title,
            type: "String",
          },
          {
            name: "Area",
            value: `${areaInMSquared.toFixed(2)}m2 (${areaInHectars.toFixed(
              2
            )}ac)`,
            type: "String",
          },
        ],
      },
    ];
  }

  get urlParams(): Record<string, any> {
    return this;
  }
}
